import { render } from "./EnbCompProds.vue?vue&type=template&id=f751839c&scoped=true"
import script from "./EnbCompProds.vue?vue&type=script&lang=js"
export * from "./EnbCompProds.vue?vue&type=script&lang=js"

import "./EnbCompProds.vue?vue&type=style&index=0&id=f751839c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f751839c"]])

export default __exports__